import { render, staticRenderFns } from "./TutorialPage.vue?vue&type=template&id=7388194f&scoped=true&"
import script from "./TutorialPage.vue?vue&type=script&lang=js&"
export * from "./TutorialPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7388194f",
  null
  
)

export default component.exports